import { render, staticRenderFns } from "./ImageBarcodeReader.vue?vue&type=template&id=a9bff776"
import script from "./ImageBarcodeReader.vue?vue&type=script&lang=js"
export * from "./ImageBarcodeReader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports